import React, { useCallback } from 'react';
import type { FC } from 'react';
import { TextInput } from '@wix/cli-ui-kit';
import { validateBusinessName } from '../validations/validate-business-name.js';

export const ChooseBusinessName: FC<{
  onSubmit: (data: { businessName: string }) => void;
}> = ({ onSubmit }) => {
  const validate = useCallback((businessName: string) => {
    try {
      validateBusinessName(businessName);
      return true;
    } catch (e) {
      return (e as Error).message;
    }
  }, []);

  return (
    <TextInput
      label="Enter the name of your business."
      onSubmit={(businessName) => onSubmit({ businessName })}
      validate={validate}
      inCreateFlow
    />
  );
};
